import React from 'react';
import { motion } from 'framer-motion';
export function FeaturesDeepDive() {
  return <section className="w-full bg-bg-primary py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        {/* BLOCK A */}
        <div className="mb-10" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-5" data-id="element-65">
            <h2 className="text-[24px] md:text-[28px] font-bold text-text-primary mb-2" data-id="element-66">
              4-Stage Visual & Audible Alert System
            </h2>
            <p className="text-[16px] text-text-secondary" data-id="element-67">
              Your eyes understand the danger before your brain processes it.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="max-w-2xl mx-auto mb-5" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/jzykVQzEq7W3Tgb7ogwbi3/foto_4_levels.png" alt="4 Levels of Visual & Audible Alarms" className="w-full h-auto rounded-xl shadow-card" data-id="element-69" />
          </motion.div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2.5" data-id="element-70">
            {[{
            color: 'bg-green-500',
            range: '0-50 PPM',
            desc: 'Safe — Green indicator breathing. No alarm.'
          }, {
            color: 'bg-yellow-400',
            range: '51-100 PPM',
            desc: 'Caution — Yellow blinking slowly. Audible alert begins.'
          }, {
            color: 'bg-accent-orange',
            range: '101-150 PPM',
            desc: 'Warning — Orange blinking fast. Loud audible alarm.'
          }, {
            color: 'bg-accent-red',
            range: '151-999 PPM',
            desc: 'Danger — Red blinking fast. Maximum alarm. Evacuate immediately.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3 + i * 0.1
          }} className="bg-bg-card border border-border-subtle rounded-lg p-3 shadow-card" data-id="element-71">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-72">
                  <div className={`w-3 h-3 rounded-full ${item.color}`} data-id="element-73"></div>
                  <div className="font-bold text-text-primary text-[15px]" data-id="element-74">
                    {item.range}
                  </div>
                </div>
                <p className="text-text-secondary text-[13px] leading-[1.4]" data-id="element-75">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* BLOCK B */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/h8d5KrvbawiAKLAe7vYXkJ/gif_seguro_000ppm.gif" alt="Plug and Play Demo" className="w-full h-auto rounded-xl shadow-card border border-border-subtle" data-id="element-78" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-79">
            <h2 className="text-[22px] font-bold text-text-primary mb-2.5" data-id="element-80">
              Protection in 3 Seconds. Literally.
            </h2>
            <div className="space-y-2.5 text-[16px] text-text-secondary leading-[1.45]" data-id="element-81">
              <p data-id="element-82">
                Plug it into any standard outlet. That's it. No drilling. No
                wiring. No electrician. No batteries that die at 3 AM when you
                need them most.
              </p>
              <p data-id="element-83">
                AirGuard Pro starts monitoring your air the instant it powers
                on. The 2-inch color display confirms you're protected — from
                across the room, day or night.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}